import "react";
import { FaMapMarkerAlt, FaInstagram } from "react-icons/fa";

const Footer = () => {
  // Smooth scroll function
  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="text-white py-8 px-[12vw] md:px-[7vw] lg:px-[20vw]">
      <div className="container mx-auto text-center">
        {/* Name / Logo */}
        <h1 className="text-xl font-semibold text-purple-500">Shrestha Fast Food & Resturant</h1>
        <h5 className="text-xl text-white-500">GOPAL NAGAR CHOWK MAIN ROAD, Siswa Bazar, Uttar Pradesh 273155</h5>
    
        {/* Navigation Links - Responsive */}
        {/* <nav className="flex flex-wrap justify-center space-x-4 sm:space-x-6 mt-4">
          {[
            { name: "About", id: "about" },
            { name: "Menu", id: "products" },
            { name: "Contact", id: "contact" },
          ].map((item, index) => (
            <button
              key={index}
              onClick={() => handleScroll(item.id)}
              className="hover:text-purple-500 text-sm sm:text-base my-1"
            >
              {item.name}
            </button>
          ))}
        </nav> */}

        {/* Social Media Icons - Responsive */}
        <div className="flex flex-wrap justify-center space-x-4 mt-6">
          {/* Consolidated Social Media Icons */}
          {[
            { icon: <FaInstagram size={24} />, link: "https://www.instagram.com/shrestha_fastfood_restaurent_?igsh=MW9nYzdybDM1Y25peQ==" },
            { icon: <FaMapMarkerAlt size={24} />, link: "https://maps.app.goo.gl/end9WaNrzkp6y4616" }, // Added size for consistency
          ].map((item, index) => (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg bg-gray-700 bg-opacity-30 hover:bg-opacity-50 hover:text-white transition-colors duration-200 flex items-center justify-center"
            >
              {item.icon}
            </a>
          ))}
        </div>

        {/* Copyright Text */}
        <p className="text-sm text-gray-400 mt-6">
          ©2025 Shrestha Resturant. All rights reserved.<br />Developed By Er.Hariom Verma
        </p>
      </div>
    </footer>
  );
};

export default Footer;
